import React from "react";
// assets
import { useAuthContext } from "../../context/providers/AuthContext";
import { showErrorMessage, showSuccessMessage, showLoadingMessage } from "../../utils/notification";
import InformationForm from "./InformationForm";
import PasswordForm from "./PasswordForm";
import Loader from "react-loader-spinner";

export default function Profile(props) {
	const { error, success, loading, clearNotification } = useAuthContext();
	const user = JSON.parse(localStorage.getItem("user"));

	React.useEffect(() => {
		if (error !== null) {
			showErrorMessage(error);
			clearNotification();
		}
		if (success != null) {
			showSuccessMessage(success);
			clearNotification();
		}
		if (loading) {
			console.log("loading en cours");
			showLoadingMessage("Please wait a moment");
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [success, error]);

	return (
		<div className="container container--main container--limited_width">
			<div className="container--default px-3 py-4 px-md-4 py-md-5">
				<h2 className="container__title">Personal information</h2>

				{user ? (
					<InformationForm userAuthenticated={user} />
				) : (
					<div className="d-md-flex">
						<div className="input__field mt-3 w-100 mt-md-4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
							<Loader type="TailSpin" color="#3326ae" height={50} width={50} />
							<p className="input__label" style={{ marginLeft: "15px" }}>
								Please wait
							</p>
						</div>
					</div>
				)}
			</div>

			<div className="container--default px-3 py-4 px-md-4 py-md-5 mt-4">
				<h2 className="container__title">Change password</h2>

				{user ? (
					<PasswordForm userAuthenticated={user} />
				) : (
					<div className="d-md-flex">
						<div className="input__field mt-3 w-100 mt-md-4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
							<Loader type="TailSpin" color="#3326ae" height={50} width={50} />
							<p className="input__label" style={{ marginLeft: "15px" }}>
								Please wait
							</p>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
